import axios from "axios";

export const sendFormData = async (formData) => {
  const url =
    "https://testacademyserver.vandal.one/api/corezoid/submit-used-devices-form";

  return await axios.post(url, formData);
};
